import { render, staticRenderFns } from "./DataSourceInDetail.vue?vue&type=template&id=31e6068a"
import script from "./DataSourceInDetail.vue?vue&type=script&lang=js"
export * from "./DataSourceInDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports